import page from '../helpers/page';
import AddressesMap from '../components/AddressesMap';
import Addresses from '../services/Addresses';
import selectors from '../globals/selectors';
import classNames from '../globals/classNames';

page(async () => {
	const addresses = await Addresses.fetch();
	const formattedCoords = addresses.map((address) => ({
		...address,
		location: address.address,
	}));
	const urlParams = new URLSearchParams(window.location.search);
	const myParam = urlParams.get('id');

	const map = new AddressesMap(selectors.contacts.addressesMap);
	const correctCoords = formattedCoords.map(coords => {
		if (myParam && myParam === coords.id) {
			return coords;
		}
	})
	const filteredCorrectCoords = correctCoords.filter((coords) => {
		return coords !== undefined;
	});

	await map.initPlacemarks(window.location.search ? filteredCorrectCoords: formattedCoords);
	await map.zoomToPlacemarks();
	await map.clickToZoom();
	await map.zoomToPlacemarksOnInit();

	// map.element.classList.remove(classNames.dNone);

	// this.#map.initPlacemarks(coords);
	// this.#map.onPlacemarkClick(this.#handleMapPlacemarkClick);

	// if (hasSelectedCoord) {
	// 	this.#map.open(selectedCoord);
	// } else {
	// 	this.#map.zoomToPlacemarks();
	// }
});
